import { useMemo } from "react"

import { prop } from "@/components/builder/utils"

import useProp from "./useProp"
import useResponsive from "./useResponsive"

const propsByCategory = items => items.reduce((acc, item) => {
  const { category = 'default' } = item
  if (!acc[category]) {
    acc[category] = []
  }
  acc[category].push(item)
  return acc
}, {})

function useAvailableProps() {
  const all = Object.values(prop.all)
    .map(item => item())
    .map(item => ({ ...item.build() }))

  const allByCategories = propsByCategory(all)
  return useMemo(() => allByCategories, [allByCategories])
}

export default function useUI() {
  const leftSidebar = useProp(LEFT_SIDEBAR_TYPE)
  const selected = useProp([])
  const interactionMode = useProp(INTERACTION_MODE)
  const responsive = useResponsive()
  const propsIgnoreDevice = useProp(['content'])
  const formattingProps = useProp({})
  const availableProps = useAvailableProps()
  const utilities = useProp([])
  const filteredProps = useProp()

  return useMemo(() => ({
    leftSidebar,
    selected,
    interactionMode,
    responsive,
    propsIgnoreDevice,
    formattingProps,
    availableProps,
    utilities,
    filteredProps,
  }), [leftSidebar, selected, interactionMode, responsive, propsIgnoreDevice, formattingProps, availableProps, utilities, filteredProps])
}

/** @type {'pages' | 'layers' | 'assets' | 'blocks'} */
const LEFT_SIDEBAR_TYPE = undefined

/** @type {'select' | 'move'} */
const INTERACTION_MODE = ''
